import React from "react";
import HeaderOne from "./HeaderOne";
import HeaderTwo from "./HeaderTwo";

export default function index() {
  return (
    <div className="">
      <HeaderOne />
      <HeaderTwo />
    </div>
  );
}
